import * as React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Fragment } from 'react';

// At some point, the unauth case should be able to pass an override
// The children of the login element are showin insetead of "login".

export const FlaxLogin = (
  props: React.HTMLAttributes<HTMLImageElement>,
  authServer: string,
) => {

  const { isLoading, isAuthenticated } = useAuth0();


  if (isLoading) {
    return <Fragment />
  }
  if (isAuthenticated) {
    return (<div>{props.children}</div>);
  } else {
    return <Fragment />
  }
};
